<wuc-display-field class="insurance-imic-car__display-field">
    <label>Auto</label>
    <ng-container slot="action">
        <!-- prettier-ignore -->
        <wuc-link
            type="secondary"
            iconSize="xs"
            [iconRight]="!showCarPanel ? 'arrow-down-bold' : 'arrow-up-bold'"
            (clicked)="showCarPanel = !showCarPanel"
        >{{ !showCarPanel ? "Downloaden" : "Sluiten" }}</wuc-link>
    </ng-container>
</wuc-display-field>
<wuc-balloon
    *ngIf="showCarPanel"
    [arrowPosition]="(isScreenSmall$ | async) ? 'topLeft' : 'topRight'"
    padding="large"
    [isFullWidth]="true"
>
    <ins-insurance-imic-buttons [purchasedProduct]="purchasedProduct"></ins-insurance-imic-buttons>
</wuc-balloon>

<wuc-display-field class="insurance-imic-car__display-field">
    <label>Aanhanger</label>
    <ng-container slot="action">
        <!-- prettier-ignore -->
        <wuc-link
            type="secondary"
            iconSize="xs"
            [iconRight]="!showTrailerPanel ? 'arrow-down-bold' : 'arrow-up-bold'"
            (clicked)="showTrailerPanel = !showTrailerPanel"
        >{{ !showTrailerPanel ? "Downloaden" : "Sluiten" }}</wuc-link>
    </ng-container>
</wuc-display-field>
<wuc-balloon
    *ngIf="showTrailerPanel"
    [arrowPosition]="(isScreenSmall$ | async) ? 'topLeft' : 'topRight'"
    padding="large"
    [isFullWidth]="true"
>
    <ins-insurance-imic-vehicle
        (completed)="showTrailerPanel = false"
        [vehicleType]="internationalInsuranceVehicleTypeEnum.Trailer"
        [purchasedProduct]="purchasedProduct"
    ></ins-insurance-imic-vehicle>
</wuc-balloon>
<wuc-display-field class="insurance-imic-car__display-field">
    <label>Caravan</label>
    <ng-container slot="action">
        <!-- prettier-ignore -->
        <wuc-link
            type="secondary"
            iconSize="xs"
            [iconRight]="!showCaravanPanel ? 'arrow-down-bold' : 'arrow-up-bold'"
            (clicked)="showCaravanPanel = !showCaravanPanel"
        >{{ !showCaravanPanel ? "Downloaden" : "Sluiten" }}</wuc-link>
    </ng-container>
</wuc-display-field>
<wuc-balloon
    *ngIf="showCaravanPanel"
    [arrowPosition]="(isScreenSmall$ | async) ? 'topLeft' : 'topRight'"
    padding="large"
    [isFullWidth]="true"
>
    <ins-insurance-imic-vehicle
        (completed)="showCaravanPanel = false"
        [vehicleType]="internationalInsuranceVehicleTypeEnum.Caravan"
        [purchasedProduct]="purchasedProduct"
    ></ins-insurance-imic-vehicle>
</wuc-balloon>
